// extracted by mini-css-extract-plugin
export var banner = "_dh-0";
export var closeButton = "_dh-2";
export var greenCheckmark = "_dh-3";
export var hereLink = "_dh-4";
export var titleIcon = "_dh-1";